import styled from "styled-components";

export const bp = {
  mobile: "480px",
  tablet: "768px",
  desktop: "1024px",
} as const;

export const SectionEyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 11px;
  color: var(--accent-2);
  margin-bottom: 12px;
`;

export const SectionTitle = styled.h2`
  font-family: "DM Serif Display", serif;
  font-size: clamp(2.1rem, 4vw, 3.4rem);
  line-height: 1;
  margin-bottom: 14px;
`;

export const SectionDescription = styled.p`
  max-width: 44rem;
  color: var(--muted);
  line-height: 1.8;
`;

export const Kicker = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-transform: uppercase;
  letter-spacing: 0.22em;
  font-size: 11px;
  color: var(--accent-2);
  margin-bottom: 22px;

  &::before {
    content: "";
    width: 54px;
    height: 1px;
    background: var(--accent-45);
  }
`;
